import { render, staticRenderFns } from "./billingCenterAdmin.vue?vue&type=template&id=34ed58bf&"
import script from "./billingCenterAdmin.vue?vue&type=script&lang=js&"
export * from "./billingCenterAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports